import { IExceptionalDays, IExceptionalDaysItem, exceptionalDays, exceptionalDaysArr } from './exceptional-days';
import momentTimezone from 'moment-timezone'
import moment from 'moment';

export const today = () => {
  return momentTimezone.tz('Asia/Tokyo')
}

today._getExpectedDate = (
  daysToAdd: number,
  format = 'YYYY/MM/DD',
  _today = today(),
): string => {
  const dayOfWeekISO = _today.format('E');
  const result = momentTimezone.tz('2022/11/28', 'YYYY/MM/DD', 'Asia/Tokyo').diff(_today);
  const isNewCycleFirst = result <= 0;

  let addDaysToReadyPrint: number = 0;

  
  if (isNewCycleFirst) {
    switch (dayOfWeekISO) {
      case '1':
        addDaysToReadyPrint = 4;
        break;
      case '2':
        addDaysToReadyPrint = 3;
        break;
      case '3':
        addDaysToReadyPrint = 6;
        break;
      case '4':
        addDaysToReadyPrint = 5;
        break;
      case '5':
        addDaysToReadyPrint = 5;
        break;
      case '6':
        addDaysToReadyPrint = 4;
        break;
      case '7':
        addDaysToReadyPrint = 3;
        break;
    }
   }  else{
    switch (dayOfWeekISO) {
      case '1':
        addDaysToReadyPrint = 7;
        break;
      case '2':
        addDaysToReadyPrint = 6;
        break;
      case '3':
        addDaysToReadyPrint = 5;
        break;
      case '4':
        addDaysToReadyPrint = 6;
        break;
      case '5':
        addDaysToReadyPrint = 5;
        break;
      case '6':
        addDaysToReadyPrint = 4;
        break;
      case '7':
        addDaysToReadyPrint = 3;
        break;
    }
   }
  return _today.add(addDaysToReadyPrint + daysToAdd, 'days').format(format);
}

today.getExceptionalDay = (
  days: IExceptionalDays,
  _today = today()
): IExceptionalDaysItem | undefined => {
  const _todayStr = _today.format('YYYY/MM/DD');

  return days[_todayStr];
}

today._getExpectedExceptionalDate = (
  type: keyof IExceptionalDaysItem,
  format?: string,
  _today = today()
): string | undefined => {
  const exceptionalDay = today.getExceptionalDay(exceptionalDays, _today);

  if (exceptionalDay) {
    const expectedDate = exceptionalDay[type];

    // * change format if not default
    if (!format || format === 'YYYY/MM/DD') {
      return expectedDate;
    }

    return momentTimezone(expectedDate).tz('Asia/Tokyo').format(format);
  }

  return undefined;
}

today.getExpectedShippingDate = (format?: string): string => {
  const _today = today();
  const exceptionalDate: string | undefined
    = today._getExpectedExceptionalDate('expectedShippingDate', format, _today);

  return exceptionalDate || today._getExpectedDate(0, format, _today);
}

today.getNextExpectedShippingDate = (format?: string): string => {
  const _today = momentTimezone(moment(today.getEndOfCycleDate(format)).add(1, 'day'), 'Asia/Tokyo');
  const exceptionalDate: string | undefined
    = today._getExpectedExceptionalDate('expectedShippingDate', format, _today);

  return exceptionalDate || today._getExpectedDate(0, format, _today);
}

today.getExpectedArrivalDate = (format?: string): string => {
  const _today = today();
  const exceptionalDate: string | undefined
    = today._getExpectedExceptionalDate('expectedArrivalDate', format, _today);

  return exceptionalDate || today._getExpectedDate(1, format, _today);
}

today._getExceptionalEndOfCycleDate = (
  format?: string,
  _today = today(),
): string | undefined => {
  const _todayStr = _today.format('YYYY/MM/DD');

  const cycle = exceptionalDaysArr.find(
    _exceptionalDays => _exceptionalDays[_todayStr]
  );

  if (cycle) {
    const cycleKeys = Object.keys(cycle);
    const expectedDate = cycleKeys[cycleKeys.length - 1];

    // * change format if not default
    if (!format || format === 'YYYY/MM/DD') {
      return expectedDate;
    }

    return momentTimezone(expectedDate).tz('Asia/Tokyo').format(format);
  }

  return undefined;
}

today._getEndOfCycleDate = (
  format = 'YYYY/MM/DD',
  _today = today(),
): string => {
  const dayOfWeekISO = _today.format('E');
  const result = momentTimezone.tz('2022/11/28', 'YYYY/MM/DD', 'Asia/Tokyo').diff(_today);
  const isNewCycleFirst = result <= 0;

  let addDaysToReadyOrder: number = 0;
  if (isNewCycleFirst) {
  switch (dayOfWeekISO) {
    case '1':
      addDaysToReadyOrder = 1;
      break;
    case '2':
      addDaysToReadyOrder = 0;
      break;
     case '3':
      addDaysToReadyOrder = 1;
       break;
    case '4':
      addDaysToReadyOrder = 0;
      break;
    case '5':
      addDaysToReadyOrder = 2;
      break;
    case '6':
      addDaysToReadyOrder = 1;
      break;
     case '7':
      addDaysToReadyOrder = 0;
       break;
  }
} else {
  switch (dayOfWeekISO) {
    case '1':
      addDaysToReadyOrder = 2;
      break;
    case '2':
      addDaysToReadyOrder = 1;
      break;
    // case '3':
    //   addDaysToReadyPrint = 0;
    //   break;
    case '4':
      addDaysToReadyOrder = 3;
      break;
    case '5':
      addDaysToReadyOrder = 2;
      break;
    case '6':
      addDaysToReadyOrder = 1;
      break;
    // case '7':
    //   addDaysToReadyPrint = 0;
    //   break;
  }
}

  return _today.add(addDaysToReadyOrder, 'days').format(format);
}

today.getEndOfCycleDate = (format?: string): string => {
  const _today = today();
  const exceptionalDate: string | undefined
    = today._getExceptionalEndOfCycleDate(format, _today);

  return exceptionalDate || today._getEndOfCycleDate(format, _today);
}
